import $ from 'jquery';

export default function slickInit() {

 
  var updateSliderCounter = function(slick) {
    var currentSlide = slick.slickCurrentSlide() + 1;
    var slidesCount = slick.slideCount;
    $(".slide-counter").text(currentSlide + '/' +slidesCount)
  };

  $('.slick--view').on('init', function(event, slick){
  	updateSliderCounter(slick);
  });

  $('.slick--view').on('afterChange', function(event, slick, currentSlide) {
    updateSliderCounter(slick);
  });

  $('.slick--view').slick({
    infinite: true,
    autoplay: true,
    adaptiveHeight: true,
    dots: false,
    arrows: true,
    nextArrow: '.slick-next',
    prevArrow: '.slick-prev'
  });
}